import { createLogic } from "redux-logic";
import type { CarConfigLogicType } from "../store";
import {
    type TradeInAemClearExtData,
    type TradeInAemSetExtData,
    type TradeInAemSetIncompatible,
    TRADE_IN_AEM_SET_INCOMPATIBLE,
    setTradeInNotification,
    TRADE_IN_AEM_CLEAR_EXT_DATA,
    TRADE_IN_AEM_SET_EXT_DATA,
    TRADE_IN_AEM_SET_NOTIFICATION,
} from "../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import { startFinanceRateFetch } from "../slices/CarConfigFinanceSlice";
import { startConfigSave } from "../slices/CarConfigSaveSlice";
import { getTradeInCashNotificationConfig } from "../../../../../common-deprecated/features/tradein/utils/tradeInAemUtils";
import { showTradeInNotification } from "../../utils/typedUtils";
import { FinanceUpdateTrigger } from "../../../../../common-deprecated/features/tradein/utils/tradeInAemUtilTypes";
import { addNotification } from "../../../../../common-deprecated/redux/actions/NotificationActions";
import { getCarConfigLabel } from "../../utils/labelUtils";

const tradeInAemExternalDataLogic = (createLogic as CarConfigLogicType<TradeInAemSetExtData>)({
    type: [TRADE_IN_AEM_SET_EXT_DATA],

    process({ getState }, dispatch, done) {
        const { tradeInAemExternalData, basket, save } = getState();

        if (tradeInAemExternalData.data?.vehicleValue) {
            // Trigger finance fetch.
            dispatch(startFinanceRateFetch({ trigger: FinanceUpdateTrigger.PxAdded }));

            // Don't need a finance rate fetch to calculate the cash notification.
            const { show, notificationType, isError } = getTradeInCashNotificationConfig(
                tradeInAemExternalData.data.vehicleValue,
                Number(basket.total.discount),
                tradeInAemExternalData.notification.cash.notificationType,
                tradeInAemExternalData.notification.cash.show,
            );

            dispatch(setTradeInNotification("cash", show, notificationType, isError));

            if (save.data) dispatch(startConfigSave());
        }

        done();
    },
});

const tradeInAemClearExternalDataLogic = (createLogic as CarConfigLogicType<TradeInAemClearExtData>)({
    type: [TRADE_IN_AEM_CLEAR_EXT_DATA],

    process(_, dispatch, done) {
        dispatch(startFinanceRateFetch({ trigger: FinanceUpdateTrigger.PxRemoved }));
        dispatch(setTradeInNotification("cash", false));
        dispatch(setTradeInNotification("monthly", false));
        dispatch(startConfigSave());
        done();
    },
});

const tradeInAemSetNotificationLogic = (createLogic as CarConfigLogicType<ReturnType<typeof setTradeInNotification>>)({
    type: [TRADE_IN_AEM_SET_NOTIFICATION],

    async process({ getState }, dispatch, done) {
        showTradeInNotification(getState(), dispatch);

        return done();
    },
});

const tradeInAemSetIncompatibleLogic = (createLogic as CarConfigLogicType<TradeInAemSetIncompatible>)({
    type: TRADE_IN_AEM_SET_INCOMPATIBLE,

    async process({ getState, action }, dispatch, done) {
        const { tradeInAemExternalData, commonSettings, carConfigSettings, utils } = getState();

        if (tradeInAemExternalData.data.quoteId) {
            const [tradeinBasketUpdateLabel, tradeinBasketAddedLabel, tradeInBasketRefusedLabel] = getCarConfigLabel(
                { commonSettings, carConfigSettings },
                [
                    "carConfigTradeinNotificationUpdate",
                    utils.financeOption === "monthly"
                        ? "carConfigTradeinNotificationAdded"
                        : "carConfigTradeinNotificationAddedCash",
                    "carConfigTradeInBasketRefusedFinanceProduct",
                ],
            );

            dispatch(
                addNotification([
                    {
                        title: tradeinBasketUpdateLabel,
                        description:
                            !tradeInAemExternalData.incompatible && !action.incompatible
                                ? tradeinBasketAddedLabel
                                : tradeInBasketRefusedLabel,
                        action: { closeButton: true },
                    },
                ]),
            );
        }

        done();
    },
});

export default [
    tradeInAemExternalDataLogic,
    tradeInAemClearExternalDataLogic,
    tradeInAemSetNotificationLogic,
    tradeInAemSetIncompatibleLogic,
];
